@if (!showInitialLoader) {
  <div>
    <div class="row justify-content-end">
      @if (list?.results?.length) {
        <div class="col col-sm-auto form-group">
          <app-custom-select
            [title]="'shared.sortBy' | cxTranslate"
            (changeValue)="sortChange($event)"
            [clearable]="true"
            [options]="sortOptions"
            [placeHolder]="'shared.select' | cxTranslate"
          ></app-custom-select>
        </div>
      }
    </div>
  </div>
}

@if (list?.results?.length) {
  <app-custom-table
    [headers]="headers"
    [columns]="columns"
    override="SavedCartRow"
    rowId="code"
    [rows]="list.results"
    [pagination]="list.pagination"
    (changePagination)="pageChange($event)"
    [showLoader]="showLoaderOnPagination"
  ></app-custom-table>
} @else {
  @if (!showInitialLoader) {
    <app-custom-error
      [errorMessage]="'importCart.noSavedCarts' | cxTranslate"
    ></app-custom-error>
  }
}


@if (showInitialLoader) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
